import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import InlineSVG from 'svg-inline-react';
import warning from '../../assets/images/warning.svg';
import success from '../../assets/images/success.svg';
import info from '../../assets/images/info.svg';
import Button from '../button/Button';

const getCssClasses = (isWarning, isSuccess, isInformation, fade, className) =>
    classNames(
        'dashboard-banner',
        ' ' + className,
        isWarning && 'dashboard-warning',
        isSuccess && 'dashboard-success',
        isInformation && 'dashboard-info',
        fade && 'dashboard-fade',
    );

const Banner = ({
    isDismissible,
    isAutoDismissible,
    isWarning,
    isSuccess,
    isInformation,
    showIcon,
    className,
    dismissHandler,
    children,
}) => {
    const [visible, setVisible] = useState(true);
    const [fade, setFade] = useState(false);

    const handleDismissClick = () => {
        setFade(true);
    };

    const transitionEnd = () => {
        setVisible(false);
        if (dismissHandler) {
            dismissHandler();
        }
    };

    if (isAutoDismissible) {
        setTimeout(() => setFade(true), 3000);
    }

    if (visible)
        return (
            <div
                className={getCssClasses(isWarning, isSuccess, isInformation, fade, className)}
                onTransitionEnd={transitionEnd}
            >
                {showIcon ? (
                    <>
                        {isWarning && (
                            <InlineSVG src={warning} className='dashboard-banner-icon dashboard-banner-warning-icon' />
                        )}
                        {isSuccess && (
                            <InlineSVG src={success} className='dashboard-banner-icon dashboard-banner-success-icon' />
                        )}
                        {isInformation && (
                            <InlineSVG src={info} className='dashboard-banner-icon dashboard-banner-info-icon' />
                        )}
                    </>
                ) : null}

                <div
                    className={classNames('dashboard-banner-content', {
                        'dashboard-no-icon': !showIcon,
                    })}
                >
                    {children}
                </div>

                {isDismissible && (
                    <Button
                        cssClasses={classNames('dashboard-banner-dismiss-button')}
                        onClick={handleDismissClick}
                    >
                        &#x2715;
                    </Button>
                )}
            </div>
        );
    return null;
};

Banner.propTypes = {
    isDismissible: PropTypes.bool,
    isAutoDismissible: PropTypes.bool,
    isWarning: PropTypes.bool,
    isSuccess: PropTypes.bool,
    isInformation: PropTypes.bool,
    showIcon: PropTypes.bool,
    className: PropTypes.string,
    dismissHandler: PropTypes.func,
    children: PropTypes.element.isRequired,
};

Banner.defaultProps = {
    isDismissible: false,
    isAutoDismissible: false,
    isWarning: false,
    isSuccess: false,
    isInformation: false,
    showIcon: true,
    className: 'dashboard-',
    dismissHandler: undefined,
};

export default Banner;
